/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { ScrollProvider } from '@matix/gatsby-theme-core';

export const wrapRootElement = ({ element }) => <ScrollProvider>{element}</ScrollProvider>;
